import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import { Collapse, IconButton, makeStyles, TableCell } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { TableRowProps } from './table-types';

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
});

export function EnhancedTableRow<T extends { id: string }>({
  children,
  row,
  expandable = false,
  AdditionalComponent,
  expanded,
  setExpanded,
}: TableRowProps<T>) {
  const classes = useRowStyles();
  const expand = expanded?.some((e) => e === row.id);

  return (
    <>
      <TableRow
        hover
        tabIndex={-1}
        className={expandable ? classes.root : undefined}
      >
        {expandable && (
          <TableCell width={50} style={{ borderBottom: 'unset' }}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setExpanded?.(row.id)}
            >
              {expand ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
        )}
        {children}
      </TableRow>
      {expandable && (
        <TableRow>
          <TableCell style={{ padding: 0 }} colSpan={6}>
            <Collapse in={expand} timeout="auto">
              {AdditionalComponent && <AdditionalComponent data={row} />}
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  );
}
